export default (that) => [
  {
    type: 'seq',
    title: '#',
    width: 50,
    fixed: 'left',
    align: 'center',
    slots: { default: 'seqno' },
  },
  {
    field: 'checkbox',
    width: 40,
    fixed: 'left',
    align: 'center',
    type: 'checkbox',
    visible: !that.isBooked,
  },
  {
    title: that.$l('INDEX.table_label_operation') || '操作',
    width: 90,
    fixed: 'right',
    slots: { default: 'opt' },
    align: 'center',
    showHeaderOverflow: true,
    visible: !that.isBooked,
  },
  {
    field: 'containerBoxQty',
    title: that.$l('table_label_containerBoxQty') || '入柜箱数',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    treeNode: false,
    slots: { default: 'containerBoxQty' },
    editRender: {
      name: 'ElInputNumber',
      props: { min: 0, size: 'mini', controlsPosition: 'right' },
    },
  },
  {
    field: 'remainCtnQty',
    title: that.$l('table_label_remainCtnQty') || '可分配箱数',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    field: 'planNo',
    title: that.$l('form_label_planNos') || '补货计划编号',
    minWidth: 150,
    group: true,
    align: 'center',
    showHeaderOverflow: true,
    slots: { header: 'planNoHeader' },
  },
  {
    field: 'fbaDc',
    title: that.$l('table_label_fbaDc') || 'FBA DC',
    minWidth: 150,
    group: true,
    align: 'center',
    showHeaderOverflow: true,
    slots: { header: 'fbaDcHeader' },
  },
  {
    field: 'totalVolume',
    title: that.$l('table_label_totalVolume') || '总体积(m³)',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    field: 'shippingFactoryName',
    title: that.$l('table_label_shippingFactoryName') || '送货工厂',
    minWidth: 220,
    group: true,
    align: 'center',
    showHeaderOverflow: true,
    slots: { header: 'shippingFactoryNameHeader' },
  },
  {
    field: 'ctnQty',
    title: that.$l('table_label_ctnQty') || '箱数',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    field: 'goodsName',
    title: that.$l('table_label_goodsName') || '产品名称',
    minWidth: 180,
    group: true,
    align: 'center',
    showHeaderOverflow: true,
    slots: { header: 'goodsNameHeader' },
  },
  {
    field: 'amzSkuNo',
    title: that.$l('table_label_sku') || 'SKU',
    minWidth: 140,
    group: true,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'amzSkuNo', header: 'amzSkuNoHeader' },
  },
  {
    field: 'amzStoreSkuNo',
    title: that.$l('table_label_storeSku') || '店铺 SKU',
    minWidth: 140,
    group: true,
    align: 'center',
    showHeaderOverflow: true,
    slots: { header: 'amzStoreSkuNoHeader' },
  },
]
